import { Checkbox, FormControlLabel, Grid, Paper } from '@mui/material';
import { useFormikContext } from 'formik';
import { useAccountHolder } from 'front-office/hooks/storage';
import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { Fragment, memo, useEffect } from 'react';
import { useUserProfile } from 'shell/hooks/use-user-profile';

const PaymentComponent = (): React.ReactElement => {
  const formContext = useFormikContext<CommonRequestCertificateInterface>();

  const { userProfile } = useUserProfile();
  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa;
  const accountHolderContext = useAccountHolder();

  useEffect(() => {
    formContext.setValues({
      ...formContext.values,
      payment: accountHolderContext.values?.payment,
      certificateInternOnly: cashManagement !== 'S',
    });
  }, []);

  useEffect(() => {
    accountHolderContext.setValues({
      payment: formContext.values.payment,
    });
  }, [formContext.values.payment]);

  return (
    <Fragment>
      <Paper elevation={3} className="pmi-px-3 pmi-pb-2">
        <Grid
          item
          xs={12}
          container
          spacing={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  id="certificate-intern"
                  disabled={cashManagement !== 'S'}
                  checked={formContext.values.certificateInternOnly || false}
                  onChange={() =>
                    formContext.setFieldValue(
                      'certificateInternOnly',
                      !formContext.values.certificateInternOnly
                    )
                  }
                  inputProps={{ 'aria-label': 'Certificato ad uso interno' }}
                />
              }
              label="Certificato ad uso interno"
            />
          </Grid>
          <Grid item xs={6} display="flex" justifyContent="flex-end">
            <div>
              Totale da pagare: <b>{`${formContext.values?.payment?.toFixed(2) || '0,00'}€`}</b>
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Fragment>
  );
};

PaymentComponent.displayName = 'Payment Form component';

const Payment = memo(PaymentComponent);

export default Payment;
